import { useDispatch, useSelector } from "react-redux"
import { Button } from "@mui/material"
import { selectIsEditingMode, selectUser, setIsSaving, setIsEditingMode, selectUserUpdatingStatus } from "./userSlice"
import { useTranslation } from "react-i18next"
import GreenSpinner from "../../components/loaders/GreenSpinner"
import { useEffect } from "react"

const Upper = () => {
    const {t} = useTranslation()
    const user = useSelector(selectUser)


    if (!user) return null

    const userType = 
        user["user-type"] === 'individual' ? t('user.individual_user') : 
        user["user-type"] === 'legal' ? t('user.juridical_user') : 
        t('user.unknown')


    return (

        <>
            {user && 
            <>
                <div className="flex flex-col sm:flex-row justify-between gap-4">
                    <div className="flex flex-col items-start justify-start text-left">
                        <span className="w-full font-bold">{userType}</span>
                        <span className="w-full">
                            {t("user.individual_code")}:{" "}
                        <span className="font-bold">{user["user-code"]}</span></span>
                    </div>
                </div>
                <div className="text-left border-2 border-emerald-600 p-2 my-4 text-sm font-medium">
                    {t("user.subscription")}
                </div>
            </>
            }
        </>

    )
}

export default Upper